/**
 * A dokumentáció szerkezete — EZ AZ EGYETLEN HELY, ahol az oldalak listája él.
 *
 * Innen épül a bal oldali menü, a morzsa (breadcrumb) és az előző/következő
 * navigáció is. Új doksi-oldal felvétele:
 *   1. `pages/docs/<id>.jsx` — az oldal tartalma, default exporttal
 *   2. `pages/docs/index.js` — a komponens beregisztrálása az id-hez
 *   3. ide egy sor a megfelelő szekcióba
 *
 * A sorrend itt egyben az "előző / következő" sorrend is.
 *
 * A bot-szekciók a bot MENÜJÉT követik (2026-09-13 óta): a szekció a felső fül
 * (AUTOPILOT, FARM, QUESTS, VISUALS, TOOLS, SETTINGS), azon belül a sorrend az
 * al-fülek sorrendje. Aki a menüben lépked, ugyanabban a sorrendben találja itt
 * is az oldalakat.
 *
 * 2026-09-29: új a Potion és az Essence (AUTOPILOT); a Combat a Key farm ELÉ
 * került (a menü is így mutatja); a Melt négy al-fülre vált (Melt runes / gems /
 * items / Open cubes) — a doksiban EGY oldal marad, mert a jobb fele közös; az
 * Auto restart 09-17 óta a LOADER része, nem a bot menüjéé.
 */
export const SIDEBAR = [
  {
    title: 'Get Started',
    items: [
      { id: 'introduction',  label: 'Introduction' },
      { id: 'requirements',  label: 'System Requirements' },
      { id: 'how-to-buy',    label: 'How to Purchase' },
      { id: 'installation',  label: 'Installation' },
    ],
  },
  {
    title: 'Using the Bot',
    items: [
      { id: 'first-run',     label: 'First Run' },
      { id: 'features',      label: 'Features Overview' },
    ],
  },
  {
    title: 'Autopilot',
    items: [
      { id: 'autopilot',     label: 'Play: Running Routes' },
      { id: 'route-builder', label: 'Editor: Building Routes' },
      { id: 'auto-combat',   label: 'Combat' },
      { id: 'key-farm',      label: 'Key Farm' },
      { id: 'party',         label: 'Party' },
      { id: 'auto-revive',   label: 'Revive' },
      { id: 'auto-potion',   label: 'Potion' },
      { id: 'auto-essence',  label: 'Essence' },
    ],
  },
  {
    title: 'Farm',
    items: [
      { id: 'farm-profiles', label: 'Profiles' },
      { id: 'auto-loot',     label: 'Loot' },
      { id: 'auto-gather',   label: 'Gather' },
      { id: 'auto-sell',     label: 'Sell' },
      { id: 'auto-melt',     label: 'Melt & Cubes' },
      { id: 'bloodshed',     label: 'Bloodshed' },
      { id: 'bag',           label: 'Bag' },
      { id: 'item-lists',    label: 'Item Lists' },
      { id: 'farm-stats',    label: 'Stats' },
    ],
  },
  {
    title: 'Quests',
    items: [
      { id: 'quests',        label: 'Daily Challenges & Fortune Hunters' },
    ],
  },
  {
    title: 'Visuals',
    items: [
      { id: 'esp',           label: 'ESP' },
      { id: 'camera',        label: 'Camera' },
      { id: 'names',         label: 'Names' },
    ],
  },
  {
    title: 'Tools & Settings',
    items: [
      { id: 'fast-mount',    label: 'Fast Mount' },
      { id: 'auto-restart',  label: 'Auto Restart (Loader)' },
      { id: 'settings',      label: 'Settings' },
    ],
  },
  {
    title: 'Troubleshooting',
    items: [
      { id: 'common-errors', label: 'Common Errors' },
      { id: 'hwid-issues',   label: 'HWID Issues' },
      { id: 'loader-errors', label: 'Loader Errors' },
    ],
  },
];

/** Lapos lista a SIDEBAR sorrendjében — az előző/következő gombokhoz. */
export const ALL_PAGES = SIDEBAR.flatMap(section =>
  section.items.map(item => ({ ...item, section: section.title }))
);

/**
 * id -> { section, label }. Korábban ez kézzel volt duplikálva a SIDEBAR
 * mellett, és a kettő el tudott csúszni egymástól; most a SIDEBAR-ból származik.
 */
export const PAGE_META = Object.fromEntries(
  ALL_PAGES.map(({ id, section, label }) => [id, { section, label }])
);

export const DEFAULT_PAGE = 'introduction';

/**
 * MEGSZŰNT OLDAL-ID-K -> az utódjuk. A régi linkek (`?page=misc`) enélkül
 * némán a bevezetőre esnének, mert az ismeretlen id a DEFAULT_PAGE-re vált.
 * 2026-09-13: a MISC fül szétesett — a Names a VISUALS, a Stats a FARM alá került.
 */
export const PAGE_ALIASES = {
  'misc': 'names',
  // 2026-10-07: nincs kulcs-aktiválás (a vásárlás magától a fiókra kerül) — a régi linkek a vásárlásra visznek.
  'activate-key': 'how-to-buy',
};
